// import { NetworkType, PublicAccount } from 'nem2-sdk';
import { IAssetsStore } from './interface';
import mutations from './mutations';

const AssetsState: IAssetsStore = {
  assetsRawHistory: {},
  assetsCreationInfo: {},
  tags: [],
};

// getters
const getters = {
  getAssetRawHistory: (state: IAssetsStore) => (publicKey: string) => {
    if (state.assetsRawHistory[publicKey]) {
      return state.assetsRawHistory[publicKey];
    } else {
      return [];
    }
  },
  getAssetCreationInfoByPublicKey: ( state: IAssetsStore ) => (publicKey: string) => {
    const pubAccount = {};
    if (true) {
      return true;
    } else {
      return;
    }
  },
  getAssetCreationInfo: ( state: IAssetsStore ) => (address: string) => {
    if (state.assetsCreationInfo[address]) {
      return state.assetsCreationInfo[address];
    } else {
      return;
    }
  },
  getTags: ( state: IAssetsStore ) => state.tags,
  getTag: ( state: IAssetsStore ) => (tagId: number) => state.tags[tagId]
};

// actions
const actions = {
};

export default {
  state: AssetsState,
  getters,
  actions,
  mutations,
};

